import styled from 'styled-components/macro'

export const Page = styled.div`
    width: 100%;
`

export const Container = styled.div`
    width: 100%;
    max-width: ${props => props.width ? props.width : '1200px'};
    margin: 0 auto;
    padding: ${props => props.padding && props.padding};
    background: ${props => props.background && props.background};
    cursor: ${props => props.cursor && props.cursor};
`

export const Flex = styled.div`
    width: ${props => props.width ? props.width : '100%'};
    height: ${props => props.height && props.height};
    max-width: ${props => props.maxWidth && props.maxWidth};
    display: flex;
	align-items: ${props => props.align ? props.align : 'center'};
	justify-content: ${props => props.justify ? props.justify : 'center'};
    padding: ${props => props.padding && props.padding};
    background: ${props => props.background && props.background};
    border-radius: ${props => props.radius && props.radius};
    border: ${props => props.border && props.border};
    border-bottom: ${props => props.borderBottom && props.borderBottom};
    border-top: ${props => props.borderTop && props.borderTop};
    border-left: ${props => props.borderLeft && props.borderLeft};
    margin: ${props => props.margin && props.margin};
    position: ${props => props.position ? props.position : 'relative'};
    z-index: ${props => props.z ? props.z : '0'};
    cursor: ${props => props.cursor && props.cursor};
    top: ${props => props.top && props.top};
    bottom: ${props => props.bottom && props.bottom};
    flex-wrap: ${props => props.flexWrap && props.flexWrap}
`

export const Block = styled.div`
    width: ${props => props.width ? props.width : '100%'};
    height: ${props => props.height && props.height};
    max-height: ${props => props.maxHeight && props.maxHeight};
    max-width: ${props => props.maxWidth && props.maxWidth};
    display: block;
    padding: ${props => props.padding && props.padding};
    background: ${props => props.background && props.background};
    border-radius: ${props => props.radius && props.radius};
    outline: ${props => props.outline && props.outline};
    border: ${props => props.border && props.border};
    border-bottom: ${props => props.borderBottom && props.borderBottom};
    border-top: ${props => props.borderTop && props.borderTop};
    border-color: ${props => props.borderColor && props.borderColor };
    margin: ${props => props.margin && props.margin};
    position: ${props => props.position ? props.position : 'relative'};
    z-index: ${props => props.z ? props.z : '0'};
    top: ${props => props.top && props.top};
    left: ${props => props.left && props.left};
    right: ${props => props.right && props.right};
    cursor: ${props => props.cursor && props.cursor};
    bottom: ${props => props.bottom && props.bottom};
    text-align: ${props => props.textAlign && props.textAlign};
    word-wrap: ${props => props.wordWrap ? props.wordWrap : 'normal'};
`

export const Inline = styled.div`
    display: inline-block;
    width: ${props => props.width && props.width};
    height: ${props => props.height && props.height};
    max-width: ${props => props.maxWidth && props.maxWidth};
    padding: ${props => props.padding && props.padding};
    background: ${props => props.background && props.background};
    border-radius: ${props => props.radius && props.radius};
    border: ${props => props.border && props.border};
    border-bottom: ${props => props.borderTop && props.borderTop};
    margin: ${props => props.margin && props.margin};
    position: ${props => props.position ? props.position : 'relative'};
    z-index: ${props => props.z ? props.z : '0'};
    cursor: ${props => props.cursor && props.cursor};
`

export const Grid = styled.div`
    display: grid;
    grid-template-columns: ${props => props.columns ? props.columns : '50% 50%'};
    column-gap: ${props => props.columnGap && props.columnGap};
    row-gap: ${props => props.rowGap && props.rowGap};
    width: ${props => props.width && props.width};
    height: ${props => props.height && props.height};
    max-width: ${props => props.maxWidth && props.maxWidth};
    padding: ${props => props.padding && props.padding};
    background: ${props => props.background && props.background};
    border-radius: ${props => props.radius && props.radius};
    border: ${props => props.border && props.border};
    border-bottom: ${props => props.borderTop && props.borderTop};
    margin: ${props => props.margin && props.margin};
    position: ${props => props.position ? props.position : 'relative'};
    grid-auto-rows: 1fr;
    z-index: ${props => props.z ? props.z : '0'};
    cursor: ${props => props.cursor && props.cursor};
    justify-items: ${props => props.justifyItems && props.justifyItems};
`

export const Logo = styled.img`
    heigth: ${props=>props.width? props.width: '18px'};
    width: ${props=>props.width? props.width: '18px'};
    margin:${props=>props.margin? props.margin: '0 0 4px 0'};
`
